

import useVuelidate from '@vuelidate/core'
import { required, minLength, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.contactTitle} - ${this.instance?.attributes.name}`,
            meta: this.infoGenerales?.attributes?.contactMeta != null && this.infoGenerales?.attributes?.contactMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.contactMeta?.replace('\n', '')) : null
        };
        // return {
        //     title: `CONTACTEZ NOUS`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: 'ICFA - Contactez-nous',
        //         },
        //         {
        //             hid: 'og-description',
        //             property: 'og:description',
        //             content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         }
        //     ]
        // };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri
        const isOpen = false
        const dublon = false

        let messageForm = {
            objetcontact: '',
            prenom: '',
            nom: '',
            email: '',
            telephone: '',
            resumeProjet: '',
            consent: '',
        };

        let formSent = false;

        let sending = false;

        return {
            strapiBaseUri,
            messageForm,
            departementExplantionNeeded: false,
            formSent, sending,
            isMounted: false,
            isOpen,
            dublon,
        }
    },

    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            messageForm: {
                objetcontact: { required },
                prenom: { required },
                nom: { required },
                consent: { required },
                email: { required, email },
                telephone: { required,mustBePhoneNumber, minLengthValue: minLength(10) },
            }

        }
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        checkCandidatureForm() {

        },
        async sendStudent() {
            try{
                if (await this.v$.$validate()) {
                    this.sending = true;

                    this.messageForm.campus = this.instance.attributes.idCampusCRM;
                    this.messageForm.url = window.location.host + "" + this.$nuxt.$route.path;
                    this.messageForm.utm = JSON.stringify(this.$store.state.utm);

                    let formData = new FormData();
                    formData.append('data', JSON.stringify(this.messageForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}contact.php?`, formData);
                    if (result == "success") {
                        this.formSent = true;
                    } else if(result.code == 'alreadyExist'){
                        // display popup
                        this.sending = false;
                        this.dublon = true;
                        this.isOpen = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }
                }
            }
            catch(error){
                this.sending = false;
                this.isOpen = true
            }

        },
    },
    async asyncData({ params, store }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP
        })[0];

        if (!store.state.instance) {
            store.commit('setInstance', instance)
        }

        let detailInfo = store.state.detailInfo;

        return {
            params, instances, instance, detailInfo, infoGenerales
        }
    },
}



